<template>
  <app-modal>
    <el-card class="box-card">
      <el-form
        @submit.native.prevent="saveEntrada"
        ref="form"
        label-position="top"
        id="image"
        v-if="show"
      >
        <el-row type="flex" justify="space-between">
          <el-col :span="11">
            <el-form-item label="Título" :class="(errorTitle ? 'error' : false)">
              <el-input v-model="entrada.title"></el-input>
              <div v-if="errorTitle" class="el-form-item__error">El título es obligatorio</div>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="Autor">
              <el-select class="w-100" v-model="entrada.author" filterable>
                <el-option
                  v-for="(author, index) in authors"
                  :key="index"
                  :value="author.id"
                  :label="author.author"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" justify="space-between">
          <el-col :span="7">
            <el-form-item label="Fecha para publicar">
              <el-date-picker
                v-model="entrada.date"
                type="date"
                placeholder="Selecciona una fecha"
                :picker-options="pickerOptions1"
                format="dd/MM/yyyy"
                value-format="yyyy-MM-DD"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Destacado">
              <el-radio-group v-model="entrada.highlighted">
                <el-radio-button :label="1">Sí</el-radio-button>
                <el-radio-button :label="0">No</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="Posición de la imagen">
              <select class="select" v-model="entrada.position">
                <option value="1">Izquierda</option>
                <option value="2">Derecha</option>
                <option value="3">Ancho total</option>
              </select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <app-cropper :options="options"></app-cropper>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="Texto" v-if="showEditor">
              <app-vue-editor :value="entrada.text"></app-vue-editor>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <button v-if="this.showBottons" type="submit" class="el-button el-button--primary">
              <span>{{btn}}</span>
            </button>
            <el-button @click="closeModal()">Atrás</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </app-modal>
</template>
<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import Cropper from "@/components/Dashboard/commons/cropper.vue";
import Modal from "@/components/Dashboard/Modals/modal";
import Editor from "@/components/_commons/vue-editor";

export default {
  name: "addEntrada",
  props: ["content", "entradaId"],
  components: {
    "app-modal": Modal,
    "app-cropper": Cropper,
    "app-vue-editor": Editor
  },
  created() {
    this.entradaId ? this.getEntrada() : (this.show = true);
    this.authors = this.getUsers();
    this.$root.$on("imagenCargada", file => {
      this.entrada.url = file;
      this.showBottons = true;
    });
    this.$root.$on("imagenEliminada", () => (this.entrada.url = false));
    this.$root.$on("vue-editor", e => {
      this.entrada.text = e;
    });
  },
  data() {
    return {
      btn: "Añadir",
      authors: false,
      entrada: {
        title: null,
        name: null,
        date: null,
        highlighted: null,
        position: null,
        text: null,
        url: null,
        author: null
      },
      options: {
        img: null,
        size: 1,
        outputType: "jpg",
        canMove: true,
        canMoveBox: false,
        class: "cropper-medium",
        info: true,
        canScale: true,
        autoCrop: true,
        autoCropHeight: 500,
        autoCropWidth: 600,
        fixed: false,
        fixedBox: true,
        centerBox: true,
        fixedNumber: [600, 500]
      },
      errorTitle: false,
      showBottons: false,
      imageOld: null,
      show: false,
      api_uploads: API_UPLOADS,
      showEditor: false,
      pickerOptions1: {
        firstDayOfWeek: 1
      }
    };
  },
  methods: {
    closeModal() {
      this.$root.$emit("closeModal");
    },
    async getUsers() {
      const response = await ApiService.post("dashboard/table", {
        table: "users",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table")
      });
      this.authors = response.data
        .map(e => {
          const ob = {};
          ob.id = e.id;
          ob.author = e.last_name + ", " + e.name;
          return ob;
        })
        .sort((a, b) =>
          a.author > b.author ? 1 : b.author > a.author ? -1 : 0
        );
    },
    async getEntrada() {
      this.btn = "Editar";
      const response = await ApiService.post("dashboard/table", {
        table: "entradas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.entradaId
      });
      this.entrada = {
        title: response.data.title,
        author: response.data.author,
        date: response.data.date,
        highlighted: response.data.highlighted,
        position: response.data.position,
        text: response.data.text,
        url: response.data.url
      };
      this.showEditor = true;
      this.options.img = this.api_uploads + response.data.url;
      this.show = true;
      this.showBottons = true;
    },
    async saveEntrada() {
      if (this.entrada.title.length > 0) {
        if (this.entrada.url.size) {
          let data = new FormData();
          data.append("file", this.entrada.url);
          const a = await ApiService.post("upload/galeries", data).then(
            response => {
              this.entrada.url = response.data;
            }
          );
        }

        if (this.entradaId > 0) {
          this.update();
        } else {
          this.insert();
        }
      } else {
        this.$message({
          type: "warning",
          message: "El campo título es obligatorio"
        });
      }
    },
    async insert() {
      const response = await ApiService.post("dashboard/editform", {
        table: "entradas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.entrada
      });
      if (response.data != "Algo ha fallado") {
        const a = ApiService.post("dashboard/editform", {
          table: "listados_entradas",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: {
            listado_id: this.content,
            entrada_id: response.data
          }
        });
        if (a.data != "Algo ha fallado") {
          this.$message({
            type: "success",
            message: "Se ha actualizado el registro"
          });
          this.tableData = this.paginador();
        } else {
          this.$message({
            type: "warning",
            message: "Algo ha fallado"
          });
        }
      }
    },
    async update() {
      const response = await ApiService.post("dashboard/editform", {
        table: "entradas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.entrada,
        id: this.entradaId
      });
      if (response.data != "Algo ha fallado") {
        this.$message({
          type: "success",
          message: "Se ha actualizado el registro"
        });
        setTimeout(() => {
          this.tableData = this.paginador();
        }, 200);
      } else {
        this.$message({
          type: "warning",
          message: "Algo ha fallado"
        });
      }
    }
  }
};
</script>
<style>
.w-100 {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Modals/addEntrada.vue